import Http from 'lib/http';
import { defaultCategoryApiParams } from '../Categories/http';
import { IListProductsResponse } from '../Products/types';

export const fetchFavorites = (shop_id: number, params?: object, fetcher = Http): Promise<IListProductsResponse> =>
  fetcher.get(`shops/${shop_id}/favorites`, {
    ...defaultCategoryApiParams,
    ...params,
  });
